import { ReactNode } from 'react';

import { DataRoomModalType } from '../enums/data-room-modal-type.enum';
import { RenameVaultFileModal } from '../vault/components/rename-vault-file-modal';
import { ManageAccessModal } from '../workspaces/components/access/manage-access-modal';
import { CreateFolderModal } from '../workspaces/components/create-folder-modal';
import { CreateSpaceModal } from '../workspaces/components/create-space-modal';
import { DataRoomSettingsModal } from '../workspaces/components/data-room-settings-modal';
import { DeleteDataRoomModal } from '../workspaces/components/delete-data-room-modal';
import { DeleteSpaceNodeModal } from '../workspaces/components/delete-space-node-modal';
import { DeleteWorkspaceModal } from '../workspaces/components/delete-workspace-modal';
import { RenameSpaceNodeModal } from '../workspaces/components/rename-space-node-modal';
import { WorkspaceSettingsModal } from '../workspaces/components/workspace-settings-modal';

export type DataRoomModalTypeComponentMap = Record<DataRoomModalType, ReactNode>;

export const dataRoomModalTypeComponentMap: DataRoomModalTypeComponentMap = {
  [DataRoomModalType.CREATE_FOLDER]: <CreateFolderModal />,
  [DataRoomModalType.CREATE_SPACE]: <CreateSpaceModal />,
  [DataRoomModalType.DATA_ROOM_SETTINGS]: <DataRoomSettingsModal />,
  [DataRoomModalType.DELETE_DATA_ROOM]: <DeleteDataRoomModal />,
  [DataRoomModalType.DELETE_SPACE_NODE]: <DeleteSpaceNodeModal />,
  [DataRoomModalType.DELETE_WORKSPACE]: <DeleteWorkspaceModal />,
  [DataRoomModalType.MANAGE_ACCESS]: <ManageAccessModal />,
  [DataRoomModalType.RENAME_SPACE_NODE]: <RenameSpaceNodeModal />,
  [DataRoomModalType.RENAME_VAULT_FILE]: <RenameVaultFileModal />,
  [DataRoomModalType.WORKSPACE_SETTINGS]: <WorkspaceSettingsModal />,
};
